import React from 'react'
import styled from "styled-components"
const PageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    padding: 1rem;
`
const Container = styled.div`
    border: 2px solid ;
    border-radius: 10px ;
    background-color: #c2c2c2a2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 3rem;
    width: 80%;
    
    
`
const Text = styled.h1`
    text-align: center;
    font-size: 1.75rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
`
const Date = styled.h1`
    text-align: center;
    font-size: 1.25rem;
    /* font-weight: bold; */
    margin-bottom: 1.5rem;
    color: red;
`
export default function Out() {
  return (
    <PageContainer>
        <Container>
            <Text>
            Your Service has "Timed Out".
            </Text>
            <Date>
                20/05/2024
            </Date>
            <Text>
            Please contact your Service Provider.
            </Text>
        </Container>
        
        
    </PageContainer>
  )
}
